import { render, staticRenderFns } from "./BrandReports.vue?vue&type=template&id=15f7d521&scoped=true&"
import script from "./BrandReports.vue?vue&type=script&lang=js&"
export * from "./BrandReports.vue?vue&type=script&lang=js&"
import style0 from "./BrandReports.vue?vue&type=style&index=0&id=15f7d521&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15f7d521",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src2332429520/src/pickl-web-app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('15f7d521')) {
      api.createRecord('15f7d521', component.options)
    } else {
      api.reload('15f7d521', component.options)
    }
    module.hot.accept("./BrandReports.vue?vue&type=template&id=15f7d521&scoped=true&", function () {
      api.rerender('15f7d521', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/SAdmin/BrandReports.vue"
export default component.exports